import getEnv from '@/getEnv';
import store from '@/store';
import { computed } from 'vue';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/auth/Login.vue')
  },
  {
    path: '/redefinir-senha',
    name: 'RedefinirSenha',
    component: () => import(/* webpackChunkName: "RedefinirSenha" */ '../views/auth/RedefinirSenha.vue')
  },
  {
    path: '/agendar',
    name: 'AgendamentoAgendar',
    component: () => import(/* webpackChunkName: "AgendamentoAgendar" */ '../views/AgendamentoAgendar.vue')
  },
  {
    path: '/meus-agendamentos',
    name: 'AgendamentoMeus',
    component: () => import(/* webpackChunkName: "AgendamentoMeus" */ '../views/AgendamentoMeus.vue')
  },
  {
    path: '/motoristas-placas',
    name: 'MotoristasPlacas',
    component: () => import(/* webpackChunkName: "MotoristasPlacas" */ '../views/MotoristasPlacas.vue')
  },
]

const router = createRouter({
  history: createWebHistory(getEnv("APP_URL")),
  routes
})

const logged_in = computed(() => store.state.auth_token != "");

router.beforeEach((to, from, next) => {
  const rotasPublicas = ["Login", "RedefinirSenha"];

  if (!rotasPublicas.includes(String(to.name)) && !logged_in.value) next({ name: "Login" });
  else next();
});

export default router
